import { lazy, Suspense } from 'react';
import LoadingSpinner from '../LoadingSpinner';

// Lazy load admin pages to reduce initial bundle size
const AdminDashboard = lazy(() => import('../../pages/admin/AdminDashboard'));
const Buildings = lazy(() => import('../../pages/admin/Buildings'));
const BuildingPricing = lazy(() => import('../../pages/admin/BuildingPricing'));
const ContractManagement = lazy(() => import('../../pages/admin/ContractManagement'));
const CreateOrganization = lazy(() => import('../../pages/admin/CreateOrganization'));
const NotifycClient = lazy(() => import('../../pages/admin/NotifycClient'));
const SmartMeters = lazy(() => import('../../pages/admin/SmartMeters'));
const SystemReports = lazy(() => import('../../pages/admin/SystemReports'));
const UserManagement = lazy(() => import('../../pages/admin/UserManagement'));
const PDFTemplates = lazy(() => import('../../pages/admin/PDFTemplates'));
const ClickPesaTesting = lazy(() => import('../../pages/admin/ClickPesaTesting'));
const SystemTests = lazy(() => import('../../pages/admin/SystemTests'));
const AccessControl = lazy(() => import('../../pages/admin/AccessControl'));
const TopUpHistory = lazy(() => import('../../pages/admin/TopUpHistory'));
const Reports = lazy(() => import('../../pages/admin/Reports'));
const ActivityLogs = lazy(() => import('../../pages/admin/ActivityLogs'));
const FinancialLogs = lazy(() => import('../../pages/admin/FinancialLogs'));
const SuperAdminBillReports = lazy(() => import('../../pages/admin/SuperAdminBillReports'));
const RoleAssignments = lazy(() => import('../../pages/admin/RoleAssignments'));

interface LazyAdminWrapperProps {
  children: React.ReactNode;
}

const LazyAdminWrapper: React.FC<LazyAdminWrapperProps> = ({ children }) => (
  <Suspense fallback={<LoadingSpinner />}>
    {children}
  </Suspense>
);

export {
  AdminDashboard,
  Buildings,
  BuildingPricing,
  ContractManagement,
  CreateOrganization,
  NotifycClient,
  SmartMeters,
  SystemReports,
  UserManagement,
  PDFTemplates,
  ClickPesaTesting,
  SystemTests,
  AccessControl,
  TopUpHistory,
  Reports,
  ActivityLogs,
  FinancialLogs,
  SuperAdminBillReports,
  RoleAssignments,
  LazyAdminWrapper
};